import React, {useEffect, useState} from 'react';
import {Alert} from "antd";
import {Accordion} from '../../../../components';
import {useViewerStore} from "../../../../store/store";
import {useCalculationStates} from '../../../../hooks/calculationStateHook';
import {FACE_IDEAL_API, MODULE_GRAPH, SHADE_CALCULATIONS} from '../../../../services/siteCalculationState';
import { RoofMesh } from '../../../../@types/types';

interface RoofWiseShadePoint {
  roofName: string;
  roofId: string;
  shadePoints: ShadePointInfo[];
}

interface ShadePointInfo {
  shadePointName: number;
  ptHashValue: number;
}

const ShadePointProperties: React.FC = () => {
    const {sceneViewer} = useViewerStore(), {roofMeshArr} = sceneViewer;
    const {needsUpdate} = useCalculationStates([FACE_IDEAL_API, SHADE_CALCULATIONS, MODULE_GRAPH]);

    const [roofWiseShadePoints, setRoofWiseShadePoints] = useState<RoofWiseShadePoint[]>([]);
    const [selectedShade, setSelectedShade] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>();

    const onClickRow = (e: React.MouseEvent<HTMLTableRowElement>) => {
        const id = (e.target as HTMLElement).id;
        setSelectedShade(id);
        const [roofFaceId, ptIdx] = id.split('-');
        if (roofFaceId) sceneViewer.selectShadePoint(roofFaceId, ptIdx);
    }

    useEffect(() => {
        roofMeshArr.forEach((roof: RoofMesh) => {
            const roofChildren = roof.children
            roofChildren.forEach((child: any) => {
                if (child.name === 'shadePoint') {
                    child.visible = true
                }
            })
        });

        return () => {
            sceneViewer.resetSelectedShade();
            roofMeshArr.forEach((roof: RoofMesh) => {
                const roofChildren = roof.children
                roofChildren.forEach((child: any) => {
                    if (child.name === 'shadePoint') {
                        child.visible = false
                    }
                })
            });
        }
    }, []);


    useEffect(() => {
        setIsLoading(Object.values(needsUpdate).includes(true));
        const roofShadeData: RoofWiseShadePoint[] = [];
        roofMeshArr.forEach((roof: RoofMesh) => {
            if (roof.userData.nameOverride || roof.userData.roof_tag_id) {
                roofShadeData.push({
                    roofName: "Roof ID-" + (roof.userData.nameOverride || roof.userData.roof_tag_id),
                    roofId: roof.roofFaceId,
                    shadePoints: roof.userData.shadeArrForRoof.map((child, index) => ({
                        shadePointName: (index + 1),
                        ptHashValue: Math.round(child.ptHashVal || 0)
                    }))
                });
            }
        })
        setRoofWiseShadePoints(roofShadeData);
    }, [needsUpdate]);

    return (
        <>
            <div className='tab__inner'>
                <div className='tab__title'>
                    <span className='tab__title--text tab__title--flex'>Shade Point Properties</span>
                </div>

                <div className='tab__column theme-based-text-color'>
                    <Accordion title='Shade Point Values' active={false}>
                        <br/>

                        <Alert style={{ marginBottom: '15px' }}
                               className="theme-based-text-color"
                               message="Shade Point Index starts from bottom left" type="info" showIcon/>
                        <Alert
                            className="theme-based-text-color"
                            message="Blue Spheres indicate the Shade points on the Roof" type="info" showIcon/>

                        {isLoading ?
                            <>
                                <br/>
                                <Alert className="theme-based-text-color"
                                       message="Shade Point values are being calculated" type="warning" showIcon/>
                            </>
                            : roofWiseShadePoints
                                .sort((a, b) => {
                                    const matchA = a.roofName.match(/\d+/);
                                    const matchB = b.roofName.match(/\d+/);
                                    const numA = matchA ? parseInt(matchA[0], 10) : 0;
                                    const numB = matchB ? parseInt(matchB[0], 10) : 0;
                                    return numA - numB;
                                })
                                .map((roof, roofIdx) => {
                                    if (roof.shadePoints.length === 0) return;
                                    return (
                                        <div
                                            key={roofIdx}>
                                            <br/>
                                            <span className='tab__column--subtitle'>{roof.roofName}</span>
                                            <div style={{height: '200px', overflow: 'auto'}}>
                                                <table className={"tab__table"} key={roofIdx}>
                                                    <thead>
                                                    <tr style={{position: 'sticky', top: '0',}}>
                                                        <th>Shade Point</th>
                                                        <th>Shade Weight Hash</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        roof.shadePoints.map((shadePoint, ptIdx) => {
                                                            return (
                                                                <tr className={selectedShade === `${roof.roofId}-${ptIdx}` ? 'selected' : ''}
                                                                    key={ptIdx} onClick={onClickRow}>
                                                                    <td id={`${roof.roofId}-${ptIdx}`}>{shadePoint.shadePointName}</td>
                                                                    <td id={`${roof.roofId}-${ptIdx}`}>{shadePoint.ptHashValue}</td>
                                                                </tr>

                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <br/>
                                        </div>
                                    )
                                })
                        }
                    </Accordion>
                </div>

            </div>
        </>
    );
}

export default ShadePointProperties;
